import { Action } from './core/action';
import ActionDispatcherService from './core/action-dispatcher.service';
import { ActionHandler } from './core/action-handler';

export default abstract class ActionAwareController implements ActionHandler {
  protected constructor(protected actionDispatcher: ActionDispatcherService) {}

  public $onInit() {
    this.actionDispatcher.register(this);
  }

  public abstract handle(action: Action);

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
  }
}



// WEBPACK FOOTER //
// src/app/common/actions/action-aware.controller.ts